<script lang="ts" setup>
  import LogoDefault from '@/components/layout/LogoDefault.vue'
  import CogOutlineIcon from 'vue-material-design-icons/CogOutline.vue'
  import { useConfigStore } from '@/stores/Config.store'

  const maintenanceCustomReason = useConfigStore().appGet('maintenance_mode-custommessage')
</script>

<template>
  <div class="h-full bg-gray-200">
    <div class="flex items-center justify-center h-screen">
      <div class="flex flex-col text-center gap-y-4">
        <LogoDefault class="mx-auto md:max-w-md mb-12" />
        <h1 class="text-4xl font-bold">Wartungsarbeiten</h1>
        <p class="text-lg text-gray-600">Wir sind bald wieder zurück!</p>
        <div class="flex justify-center">
          <div
            class="gear m-2 animate-bounce-delayed"
            style="animation-delay: 0s">
            <div class="animate-spin-slow">
              <CogOutlineIcon class="w-16 h-16" />
            </div>
          </div>

          <div
            class="gear m-2 animate-bounce-delayed"
            style="animation-delay: 1s">
            <div class="animate-spin-slow">
              <CogOutlineIcon class="w-16 h-16" />
            </div>
          </div>

          <div
            class="gear m-2 animate-bounce-delayed"
            style="animation-delay: 2s">
            <div class="animate-spin-slow">
              <CogOutlineIcon class="w-16 h-16" />
            </div>
          </div>
        </div>

        <p class="text-md text-gray-600">(Die Anwendung wird automatisch fortgesetzt.)</p>

        <Card
          v-if="maintenanceCustomReason"
          :pt="{ root: ['p-2'], body: ['p-0 px-2'], content: ['p-0'], subtitle: ['text-left underline text-xs'] }"
          :pt-options="{}"
          class="mt-8 border text-base mx-auto md:max-w-4xl bg-yellow-100">
          <template #subtitle>Zusätzliche Information:</template>
          <template #content>
            {{ maintenanceCustomReason }}
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>
